import { CSSProperties } from "react"

export const StylesProps3: CSSProperties = {
    backgroundColor: "#ff5100",
    color: "white"
}

export const StyleProps4: CSSProperties = {
    backgroundColor: "#d9d9f2"
}

export const StyleProps5: CSSProperties = {
    color: "black"
}

export const StyleProps8: React.CSSProperties = {
    color: "white",
    marginRight: "4px"
}

export const stylesProps1:CSSProperties ={
    color: "white"
}

export const StylesProps2:CSSProperties = {
 backgroundColor: "#304aca"
}
